import type { InsuranceVerdict } from '@/hooks/useInsuranceVerdicts'

// The words the console shows for the middleware's insurance verdict (insuranceVerdicts) —
// the same vocabulary as the provider app and Billing V2.

export const PAYER_ELIGIBILITY_LABELS: Record<InsuranceVerdict['payerEligibility'], string> = {
  verified: 'Verified',
  'approved-manually': 'Approved Manually',
  disapproved: 'Disapproved',
  'not-verified': 'Not Verified',
  none: 'No Coverage',
}

export function payerEligibilityColor(status: InsuranceVerdict['payerEligibility']): string {
  if (status === 'verified' || status === 'approved-manually') return 'green'
  if (status === 'none') return 'gray'
  return 'red'
}

export const INSURANCE_STATUS_LABELS: Record<InsuranceVerdict['insuranceStatus'], string> = {
  verified: 'Insurance verified',
  'review-required': 'Insurance review required',
  none: 'No insurance',
}

export function clinicDecisionLabel(decision: InsuranceVerdict['clinicDecision']): string {
  if (decision === 'approve') return 'Accepted by clinic'
  if (decision === 'disapprove') return 'Declined by clinic'
  return 'No decision'
}
